<form class="dynamic-form" [formGroup]="form" (submit)="onSubmit($event)" style="width: 100%">
  <div [fxLayout]="fxLayout" [fxLayoutAlign]="fxLayoutAlign" [fxLayoutGap]="fxLayoutGap">
    <ng-container *ngFor="let field of formFields;">
      <div *ngIf="!field.hidden" [fxFlex]="field.fxFlex">
        <ng-container optsol-ngx-dynamicField [field]="field" [group]="form">
        </ng-container>
      </div>
    </ng-container>
  </div>
</form>
<!-- <pre>
  {{errors | json}}
</pre> -->
